export var trimTrailingSlash = function (mapping) {
    if (mapping === void 0) { mapping = ''; }
    return mapping === null || mapping === void 0 ? void 0 : mapping.replace(/\/+$/, '');
};
